import { Type } from "@sinclair/typebox";
import { MessageSchema } from "./message";
import { IdLike, NullableString } from "../../../utils/typeboxTypes";
import { MsgrConversationStatusSchema } from "../../../database/models";
export const PagedMessages = Type.Object({
    /**
     * The number of messages per page.
     */
    per_page: Type.Number(),
    /**
     * URL or Token to get the next page of messages.
     */
    next_cursor: Type.Union([Type.String(), Type.Null()]),
    /**
     * URL or Token to get the previous page of messages
     */
    prev_cursor: Type.Union([Type.String(), Type.Null()]),
    /**
     * The messages in the current page.
     */
    items: Type.Array(MessageSchema),
    /**
     * Record of unread message ID, to date and time the message was created.
     */
    unreadMessages: Type.Optional(Type.Record(Type.String({
        title: "MessageId",
    }), Type.String({ title: "CreatedAt" }))),
}, {
    title: "PagedMessages",
});
export const Conversation = Type.Object({
    /**
     * ID of the conversation.
     */
    id: Type.String(),
    /**
     * Status of the conversation.
     */
    status: MsgrConversationStatusSchema,
    /**
     * ID of the chatflow.
     */
    chatflow_id: Type.Optional(NullableString),
    /**
     * ID of the ticket.
     */
    ticket_id: Type.Optional(IdLike),
    /**
     * Messages in the conversation.
     */
    messages: PagedMessages,
}, {
    title: "Conversation",
});
